module.exports = __webpack_public_path__ + "img/kbi.9348df75.png";